import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function LightbulbSolidGroupIcon(props) {
	return (
		<IconBase type="lightbulb-solid-group" {...props}>
			<path d="M7 21C7 21.55 7.45 22 8 22H12C12.55 22 13 21.55 13 21V20H7V21Z" />
			<path d="M10 2C6.14 2 3 5.14 3 9C3 11.38 4.19 13.47 6 14.74V17C6 17.55 6.45 18 7 18H13C13.55 18 14 17.55 14 17V14.74C15.81 13.47 17 11.38 17 9C17 8.99152 17 8.98304 17 8.97457L16.9999 8.97202C16.9875 5.8189 14.88 3.151 12 2.291C11.3661 2.1017 10.6947 2 10 2Z" />
			<path d="M15.8287 18H17C17.55 18 18 17.55 18 17V14.74C19.81 13.47 21 11.38 21 9C21 5.83169 18.8845 3.14846 15.9918 2.28856C17.8371 3.93759 19 6.33492 19 9C19 11.6733 17.8322 13.0967 16 14.74V17C16 17.3505 15.9396 17.6871 15.8287 18Z" />
			<path d="M16 22H14.8287C14.9396 21.6871 15 21.3505 15 21V20H17V21C17 21.55 16.55 22 16 22Z" />
		</IconBase>
	);
}

LightbulbSolidGroupIcon.propTypes = iconPropTypes;
